<template>
	<v-col cols='12' md='6'  class="text-center">
		<div class="lottie" ref="lottie" data-bm-renderer="svg" />
	</v-col>
</template>

<script>
import lottie from 'lottie-web'

export default {
	name: 'LogoAnimation',
	mounted() {
		lottie.loadAnimation({
			container: this.$refs.lottie, // the dom element that will contain the animation
			renderer: 'svg',
			loop: false,
			autoplay: true,
			path: 'logoAnimation.json', // the path to the animation json
		})
	},
}
</script>